import { programsApi } from '@/admin/api/programs';
import EditProgram from '@/admin/pages/programs/edit-program';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/programs/$programId/edit')({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData({
			queryKey: ['program', params.programId],
			queryFn: () => programsApi.get(Number(params.programId)),
		}),
	component: EditProgram,
});
